const flights = {
  flight: "Vlucht", // translated
  flights: "Vluchten", // translated
  originDepartureDate: "Vertrek", // translated
  destinationDepartureDate: "Opbrengst", // translated
  outbound: "Uitgaande", // translated
  inbound: "Inkomend", // translated
  travelTime: "Reistijd", // translated
  selected: "geselecteerd", // translated
  select: "selecteren", // translated
  airline: "Luchtvaartmaatschappij", // translated
  directFlight: "Directe vlucht", // translated
  baggage: "Bagage", // translated
  stops: "Stopt", // translated
  nonStop: "Non-stop", // translated
  oneStopMax: "Maximaal één stop", // translated
  twoStopsMax: "Maximaal twee stops", // translated
  anyStops: "Met eventuele tussenstops", // translated
  smallBaggage: "Kleine bagage", // translated
  bigBaggage: "Grote bagage", // translated
  smallAndBigBaggage: "Kleine en grote bagage", // translated
  outboundStops: "Uitgaande stops", // translated
  inboundStops: "Inkomende stops", // translated
  selectAirline: "Selecteer luchtvaartmaatschappij", // translated
  baggageOption: "Bagage optie", // translated
  outboundDepartureAfter: "Uitgaand vertrek na", // translated
  outboundArrivalAfter: "Uitgaande aankomst na", // translated
  inboundDepartureAfter: "Inkomend vertrek na", // translated
  inboundArrivalTimeAfter: "Inkomende aankomst na", // translated
  flightClass: "Vluchtklasse", // translated
  outboundDepAfter: "Uit vertrek na", // translated
  outboundArrivalAfrer: "Aankomst na", // translated
  inboundDepAfter: "Bij vertrek na", // translated
  inboundArrivalAfter: "Bij aankomst na", // translated
  airlines: "Luchtvaartmaatschappij(en)", // translated
  lessThan: "Minder dan", // translated
  layover: "Tussenstop", // translated
  duration: "Duur", // translated
  economy: "Economie", // translated
  business: "Bedrijf", // translated
  with: "Met", // translated
  without: "Zonder", // translated
  twoOrMore: "Twee of meer", // translated
  departure: "Vertrek", // translated
  return: "Opbrengst", // translated
  submit: "Indienen", // translated
  priceLessThan: "Prijs minder dan", // translated
  durationLessThan: "Duur korter dan", // translated
  layoverLessThan: "Tussenstop minder dan", // translated
  noLayover: "Geen tussenstop", // translated
  durationLowestFirst: "Duur (laagste eerst)", // translated
  durationHighestFirst: "Duur (hoogste eerst)", // translated
  idType: "ID Type", // translated
  idPassportCode: "ID/paspoortcode", // translated
  expirationDate: "uiterste houdbaarheidsdatum", // translated
  frequentFlyerNumber: "Frequent Flyer-nummer", // translated
  frequentFlyerAirline: "Frequent Flyer-luchtvaartmaatschappij", // translated
  dateOfBirth: "Geboortedatum", // translated
  infant: "Zuigeling", // translated
  phone: "Telefoon", // translated
  title: "Titel", // translated
  noLuggageIncluded: "Geen bagage inbegrepen", // translated
  includesLuggage: "Inclusief bagage", // translated
  outboundFlight: "Uitgaande vlucht", // translated
  inboundFlight: "Inkomende vlucht", // translated
  flightNumber: "Vluchtnummer", // translated
  flightNumbers: "Vluchtnummers", // translated
  cabinClassType: "Type cabineklasse", // translated
  aircraftType: "Vliegtuig type", // translated
  airlineName: "Naam luchtvaartmaatschappij", // translated
  no: "Nee", // translated
  yes: "Ja", // translated
  anyFlights: "Eventuele vluchten", // translated
  oneStop: "Een stop", // translated
  direct: "Direct", // translated
  directFlights: "Directe vlucht", // translated
  all: "Alle", // translated
  first: "Eerst", // translated
  premiumEconomy: "Prem. Economie", // translated
  withBaggageOnly: "Alleen met bagage", // translated
  oneWay: "Een manier", // translated
  roundTrip: "Rondvaart", // translated
  withBaggage: "Met bagage", // translated
  noBaggage: "Geen bagage", // translated
  requiredFields: "Verplichte velden", // translated
  nonRequiredFields: "Niet-vereiste velden", // translated
  cabinClass: "Cabineklasse", // translated
  brandName: "Merknaam", // translated
  performNewSearch: "Voer een nieuwe zoekopdracht uit", // translated
  outboundDeparture: "Uitgaand vertrek", // translated
  inboundDeparture: "Inkomend vertrek", // translated
  created: "Gemaakt", // translated
  freeCancellationAvailable: "Gratis annuleren mogelijk", // translated
  freeCancellationDeadline: "Gratis annuleringstermijn", // translated
  externalReference: "Externe referentie", // translated
  outboundflightNumber: "Uitgaande vluchtnummer", // translated
  inboundflightNumber: "Inkomend vluchtnummer", // translated
  arrival: "Aankomst", // translated
};

export default flights;
